<template>
  <div
    class="mb-2"
  >
    <div class="icon-text" :class="centerClass">
      <IconTrebol style="width: 25px; margin-right: 5px;" />
      <span :class="`${fontFamily} m-0`" v-html="text"></span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import IconTrebol from '@/components/Icons/TrebolSvg.vue'

export default defineComponent({
  props: {
    text: {
      type: String,
      default: '',
    },
    fontFamily: {
      type: String,
      default: 'font-noto-r',
    },
    centerClass: {
      type: String,
      default: ''
    }
  },
  components: {
    IconTrebol
  },
})
</script>

<style scoped>
.icon-text {
  display: grid;
  grid-template-columns: 30px auto;
}

.place-center {
  place-content: center;
  place-items: center;
}
</style>
